import "./App.css";
import React, { Component } from "react";

class App extends Component {
  state = {
    weatherData: [],
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const city = e.target.userInput.value;
    fetch(
      `https://api.openweathermap.org/data/2.5/forecast/daily?q=${city}&mode=json&units=metric&cnt=5&appid=fbf712a5a83d7305c3cda4ca8fe7ef29`
    )
      .then((res) => res.json())

      .then((data) => this.setState({ weatherData: [data] }));
  };
  render() {
    const date = Date();
    console.log(this.state.weatherData);

    return (
      <div className="App">
        <h1>Weather App</h1>
        <form onSubmit={this.handleSubmit}>
          <input
            name="userInput"
            className="searchBox"
            type="text"
            placeholder="search"
          />
        </form>
        {this.state.weatherData.map((data) => (
          <div>
            <h1 className="cityName" key={data.city.id}>
              {data.city.name}, {data.city.country}
            </h1>
            <h2>{data.list[0].weather[0].description}</h2>
            <h3>{data.list[0].temp.day}°C</h3>
            <h3>Humidity: {data.list[0].humidity}</h3>
            <h3>{date}</h3>
          </div>
        ))}
      </div>
    );
  }
}

export default App;
